import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView} from '/component/base/Storybook';

import Default from './Default';

storiesOf('base', module).add('Carousel', () => (
  <ScrollView>
    <FlexView>
      <Default />
    </FlexView>
  </ScrollView>
));
